import React, { useMemo } from 'react';
import { getDetailUnifiedCols } from "../../helpers/unified";
import { getStickyColumns, localization, modifyDefaultOptions } from "../../helpers/table";
import MaterialTable from "material-table";
import {tableIcons} from "../../helpers";

const DetailUnifiedPc = (props) => {
  const {originalData, title, handleLevel, components, entity, ...rest} = props
  const allCols =  useMemo(() => rest?.cols ?? getDetailUnifiedCols(originalData, handleLevel), [originalData])

  const getColumns = () => {
    return [
      ...getStickyColumns(allCols?.filter(x => !!x?.sticky), entity === 'contracts' ? 48 : 0),
      ...allCols?.filter(x => !x?.sticky),
    ];
  };

  return (
    <div style={{ maxWidth: '100%' }} className={entity === 'contracts' ? 'table-with-parentChildData' : ''}>
      <MaterialTable
        icons={tableIcons}
        localization={localization}
        columns={getColumns()}
        data={originalData}
        components={components}
        title={title}
        parentChildData={entity === 'contracts' ? (row, rows) => rows.find((rowsItem) => rowsItem.id === row.parentId) : null}
        options={modifyDefaultOptions({
          columnsButton: true,
          maxBodyHeight: 'calc(100vh - 400px)',
          rowStyle: (rowData) => ({
            backgroundColor: !rowData.parentId ? '#f5f5ff' : '#FFF',
            whiteSpace: 'pre-wrap',
          }),
          paging: false,
          headerStyle: {
            height: 50,
            position: 'sticky',
            left: 0,
          },
          filterCellStyle: {
            position: 'sticky',
            left: 0,
            top: 71,
            background: 'white',
          },
        })}
      />
    </div>
  );
}

export default DetailUnifiedPc;
